<template>
  <div>
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col-12 col-lg">
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <strong>Agencia:</strong> {{ agencia }}
            </li>
            <li class="list-inline-item">
              <strong>Código:</strong> {{ codigo }}
            </li>
          </ul>
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <strong>Pasajero:</strong> {{ pasajero }}
            </li>
            <li class="list-inline-item">
              <strong>Idioma:</strong> {{ idioma }}
            </li>
            <li class="list-inline-item"><strong>PAX:</strong> {{ pax }}</li>
            <li class="list-inline-item" v-if="chd">
              <strong>CHD:</strong> {{ chd }}
            </li>
            <li class="list-inline-item">
              <strong>Fecha Liquidación:</strong> {{ fecha }}
            </li>
          </ul>
        </div>
        <div class="col-12 col-lg-3 text-sm-right">
          <button class="btn btn-outline-secondary btn-sm" @click="onPrint">
            Imprimir
          </button>
        </div>
      </div>
    </div>
    <div class="pb-2">
      <DetalleLiquidacionTable :rows="items" :total="total" />
    </div>
  </div>
</template>

<script>
import DetalleLiquidacionTable from "./DetalleLiquidacionTable.vue";
import liquidacionDetallePdf from "../pdfs/liquidacionDetalle.pdf";
import total from "../helpers/total.helper";

export default {
  components: {
    DetalleLiquidacionTable
  },
  props: {
    agencia: String,
    codigo: String,
    pasajero: String,
    idioma: String,
    pax: [String, Number],
    chd: [String, Number],
    fecha: String,
    items: Array
  },
  computed: {
    total() {
      return total(this.items);
    }
  },
  methods: {
    onPrint() {
      const items = this.items.map(item => ({
        ...item,
        moneda: {
          alignment: "center",
          text: item.moneda
        },
        monto: {
          alignment: "right",
          text: item.monto
        }
      }));

      for (const [moneda, total] of Object.entries(this.total)) {
        items.push({
          fecha: {
            colSpan: 5,
            alignment: "right",
            text: `TOTAL ${moneda}`
          },
          servicio: "",
          hotel: "",
          tipo: "",
          monto: {
            alignment: "right",
            text: this.$options.filters.number(total, 2)
          },
          observaciones: ""
        });
      }

      liquidacionDetallePdf({
        items: items,
        header: {
          agencia: this.agencia,
          codigo: this.codigo,
          pasajero: this.pasajero,
          idioma: this.idioma,
          pax: this.pax,
          chd: this.chd,
          fecha: this.fecha
        },
        userMark: this.$store.state.user,
        dateMark: this.$dayjs().format("DD-MM-YY HH:mm")
      });
    }
  }
};
</script>

<style></style>
